export default {
  // 用户信息
  'account.center.userId': '用户ID',
  'account.center.nickname': '昵称',
  'account.center.status': '状态',
  'account.center.status.active': '正常',
  'account.center.roles': '角色',
  'account.center.lastLogin': '最近操作',
  'account.center.createdAt': '注册时间',
  'account.center.copyFailed': '复制失败',

  // Tab
  'account.center.tab.overview': '概览',
  'account.center.tab.team': '我的团队',
  'account.center.tab.records': '分润记录',

  // 邀请码
  'account.center.referral.title': '邀请推广',
  'account.center.referral.myCode': '我的邀请码',
  'account.center.referral.copy': '复制',
  'account.center.referral.copyCode': '复制邀请码',
  'account.center.referral.copyLink': '复制邀请链接',
  'account.center.referral.copyLinkBtn': '复制链接',
  'account.center.referral.copied': '邀请码已复制',
  'account.center.referral.linkCopied': '邀请链接已复制',
  'account.center.referral.notBound': '您还没有绑定邀请码',
  'account.center.referral.bindNow': '立即绑定',
  'account.center.referral.boundTo': '已绑定邀请码',
  'account.center.referral.bindSuccess': '邀请码绑定成功',
  'account.center.referral.bindFailed': '绑定失败，请重试',
  'account.center.referral.invalidCode': '邀请码无效或不存在',
  'account.center.referral.alreadyBound': '您已绑定过邀请码',
  'account.center.referral.selfNotAllowed': '不能绑定自己的邀请码',

  // 绑定弹窗
  'account.center.referral.bindModal.title': '绑定邀请码',
  'account.center.referral.bindModal.label': '邀请码',
  'account.center.referral.bindModal.placeholder': '请输入6位邀请码',
  'account.center.referral.bindModal.required': '请输入邀请码',
  'account.center.referral.bindModal.format': '邀请码格式为6位字母数字',
  'account.center.referral.bindModal.cancel': '取消',
  'account.center.referral.bindModal.submit': '确认绑定',

  // 下级列表
  'account.center.downlines.title': '直推成员',
  'account.center.downlines.direct': '直推人数',
  'account.center.downlines.userId': '用户ID',
  'account.center.downlines.email': '邮箱',
  'account.center.downlines.joinedAt': '加入时间',
  'account.center.downlines.totalCount': '共 {total} 人',
  'account.center.downlines.empty': '暂无直推成员',

  // 等级信息
  'account.center.level.activated': '已激活',
  'account.center.level.notActivated': '未激活',
  'account.center.level.activateHint': '您需要激活至少一张卡片才能参与分润',
  'account.center.level.activatedCards': '激活卡片',
  'account.center.level.myActivatedCards': '我的激活卡片',
  'account.center.level.myCardsHint':
    '您已激活的卡片数量。激活卡片后即可参与分润奖励。',
  'account.center.level.upgradeToNext': '升级至 {level}',
  'account.center.level.directCount': '直推人数',
  'account.center.level.teamCards': '团队卡片',

  // 收益
  'account.center.earnings.total': '总收益',
  'account.center.earnings.pending': '待领取',
  'account.center.earnings.claimed': '已领取',
  'account.center.earnings.frozen': '冻结中',
  'account.center.earnings.claim': '领取',
  'account.center.earnings.claimSuccess': '成功领取 {amount}',
  'account.center.earnings.claimFailed': '领取失败',
  'account.center.earnings.noPending': '暂无待领取收益',
  'account.center.earnings.breakdown': '收益明细',
  'account.center.earnings.direct': '直推奖励',
  'account.center.earnings.levelDiff': '极差奖励',
  'account.center.earnings.teamBonus': '团队奖励',

  // 分润记录
  'account.center.commission.records': '分润记录',
  'account.center.commission.column.time': '时间',
  'account.center.commission.column.rewardType': '奖励类型',
  'account.center.commission.column.sourceType': '来源',
  'account.center.commission.column.amount': '金额',
  'account.center.commission.column.baseAmount': '基础金额',
  'account.center.commission.column.rate': '费率',
  'account.center.commission.column.status': '状态',

  // 奖励类型
  'account.center.commission.type.direct': '直推奖励',
  'account.center.commission.type.levelDiff': '极差奖励',
  'account.center.commission.type.teamBonus': '团队奖励',

  // 来源类型
  'account.center.commission.source.cardActivated': '开卡激活',
  'account.center.commission.source.rechargeFee': '充值手续费',
  'account.center.commission.source.withdrawal': '提现手续费',

  // 状态
  'account.center.commission.status.pending': '待领取',
  'account.center.commission.status.frozen': '冻结中',
  'account.center.commission.status.settled': '已结算',
  'account.center.commission.status.claimed': '已领取',
};
